import { Pipe, PipeTransform } from '@angular/core';
import { getActivitySectionState } from './activity.functions';

@Pipe({
  name: 'activitySectionState'
})
export class ActivitySectionStatePipe implements PipeTransform {
    transform(action?: string): string {
        return getActivitySectionState(action);
    }
};